import { ButtonGroup, Col, Row } from 'react-bootstrap';
import { UserPrincipal } from '../../permissions/userPrincipal';
import { ButtonWithIcon } from '../UIExtentions/Buttons';
import { Permission as PermissionString } from '../../permissions/permission';
import React, { useCallback, useEffect } from 'react';
import { ScopedUserPrincipal } from '../../permissions/ScopedUserPrincipal';
import { AppPoolAction } from '../../constants/AppPoolAction';

interface AppPoolsServerManagementButtonsProps {
    selectedServers: string[];
    userPrincipal: UserPrincipal;
    serversUserPrincipal: ScopedUserPrincipal;
    onClickCallback: (action: AppPoolAction) => Promise<void>;
}
// big buttons
export const AppPoolsServerManagementButtons = (props: AppPoolsServerManagementButtonsProps) => {
    const selectedServers = props.selectedServers;
    const userPrincipal = props.userPrincipal;
    const serversUserPrincipal = props.serversUserPrincipal;
    const onClickCallback = props.onClickCallback;

    const getEnableState = useCallback(
        function (permission: PermissionString): boolean {
            return !!selectedServers.length && (userPrincipal.hasPermission(permission) || serversUserPrincipal?.hasPermission(selectedServers, permission));
        },
        [selectedServers, serversUserPrincipal, userPrincipal]
    );

    const [canStart, setCanStart] = React.useState(getEnableState(PermissionString.AppPool_Start));
    const [canStop, setCanStop] = React.useState(getEnableState(PermissionString.AppPool_Stop));
    const [canRefresh, setCanRefresh] = React.useState(getEnableState(PermissionString.AppPool_Refresh));
    const [canRecycle, setCanRecycle] = React.useState(getEnableState(PermissionString.AppPool_Recycle));

    const UpdatePermissions = useCallback(() => {
        setCanStart(getEnableState(PermissionString.AppPool_Start));
        setCanStop(getEnableState(PermissionString.AppPool_Stop));
        setCanRefresh(getEnableState(PermissionString.AppPool_Refresh));
        setCanRecycle(getEnableState(PermissionString.AppPool_Recycle));
    }, [getEnableState]);

    useEffect(() => {
        UpdatePermissions();
    }, [UpdatePermissions]);

    return (
        <Row style={{ marginBottom: '5px' }}>
            <Col>
                <ButtonGroup style={{ width: '100%' }}>
                    <ButtonWithIcon
                        disabled={!canRecycle}
                        variant="blue"
                        icon="fa-recycle"
                        textColor="white"
                        text="Recycle"
                        onClick={() => onClickCallback(AppPoolAction.Recycle)}
                    />
                </ButtonGroup>
            </Col>
            <Col>
                <ButtonGroup style={{ width: '100%' }}>
                    <ButtonWithIcon
                        disabled={!canStart}
                        variant="green"
                        icon="fa-play-circle"
                        textColor="white"
                        text="Start"
                        onClick={async () => await onClickCallback(AppPoolAction.Start)}
                    />
                    <ButtonWithIcon
                        disabled={!canStop}
                        variant="red"
                        icon="fa-stop-circle"
                        textColor="white"
                        text="Stop"
                        onClick={async () => await onClickCallback(AppPoolAction.Stop)}
                    />
                </ButtonGroup>
            </Col>
            <Col>
                <ButtonGroup style={{ width: '100%' }}>
                    <ButtonWithIcon
                        disabled={!canRefresh}
                        variant="dark-blue"
                        icon="fa-refresh"
                        textColor="white"
                        text="Refresh"
                        onClick={() => onClickCallback(AppPoolAction.Refresh)}
                    />
                </ButtonGroup>
            </Col>
        </Row>
    );
};
